import React, { useEffect, useState } from "react";
import {
	Button,
	Modal,
	Typography,
	Checkbox,
	Table,
	TextField,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Grid,
	Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

import fondo_productos from "../../../images/fondo_productos_company.png";
import { ApiService } from "../../ApiService";
import imagen_producto from "../../../images/imagen_card_prueba.jpeg";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { ImagenesGlobal } from "../../global/ImagenesGlobal";

const marcas = [
	{
		id: 1,
		image: "https://totalherramientas.com.ar/wp-content/uploads/2019/08/logo-total-variante4.png",
		name: "Marca1",
	},
	{
		id: 2,
		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnin0D_MSALbfYxgbZD9EVyoJyCAoowrxz5Q&s",
		name: "Marca2",
	},
	{
		id: 3,
		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnHW5DaI8Fpg0Kzwl1bVQFQstlO4EAwjGoDw&s",
		name: "Marca3",
	},
	{
		id: 4,
		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRb3Ypu70Gkx7V8j3UrIwomNkGgaKMjBizZFg&s",
		name: "Marca4",
	},
];

const MAX_SELECTED = 8;

const HomeProductosEdit = ({ currentIndexBrands, handlePrevBrands, handleNextBrands, key_branch, loadImageS, convertPrice = (() => { }) }) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [productos, setProductos] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [marcas, setMarcas] = useState([]);
	const API_URL = process.env.REACT_APP_API_URL;

	const { nit } = useParams();

	// Cuando se hace check/uncheck
	const handleToggleProduct = async (obj) => {
		// Comprobar si el producto ya está en la lista seleccionada
		const isSelected = selectedProducts.filter((e) => e?.key_product == obj?.key_product).length > 0;

		if (!isSelected && selectedProducts.length >= MAX_SELECTED) return toast.error("Máximo 8 productos, solo se puede habilitar");

		try {
			const result = await ApiService.fetchData(
				`api/company/product/view?key_branch=${key_branch}&key_product=${obj?.key_product}`,
				{
					method: "PUT",
				}
			);

			if (result?.code == 200) {
				obj.selected = !obj.selected;

				setSelectedProducts((current_list) => {
					let newList = [];
					if (isSelected) {
						newList = current_list.filter((item) => item?.key_product != obj?.key_product);
					} else {
						newList = [...current_list, obj];
					}

					return newList.sort((objA, objB) => objA.fullName.localeCompare(objB.fullName));
				});
			}
		} catch (error) {
			console.error("Error al actualizar el producto en el backend:", error);
		}
	};


	const handleCloseModal = () => {
		setModalOpen(false);
	};

	useEffect(() => {
		const fetchMarcas = async () => {
			try {
				const data = await ApiService.fetchData(`api/company/brand/list?key_branch=${key_branch}`, {
					method: "GET",
				});
				if (Array.isArray(data)) {
					// Ajusta si tu backend da otra propiedad con el logo
					// Por ejemplo: data[i].logo_path
					setMarcas(data);
				}
			} catch (e) {
				console.error("Error al obtener las marcas:", e);
			}
		};
		fetchMarcas();
	}, [key_branch]);

	// Cargar todos los productos desde inicio
	useEffect(() => {
		const fetchProductos = async () => {
			const data = await ApiService.fetchData(`api/company/product/global-list?key_branch=${key_branch}`, {
				method: "GET",
			});
			if (Array.isArray(data)) {
				setProductos(data);
				const seleccionados = data.filter((p) => p.selected).sort((objA, objB) => objA.fullName.localeCompare(objB.fullName));
				setSelectedProducts(seleccionados);
			}
		};
		fetchProductos();
	}, [key_branch]);

	const translateX = `translateX(-${currentIndexBrands * 25}%)`;
	const widthDynamic = `${marcas.length * 20}%`;

	const filteredProducts = productos.filter(
		(prod) =>
			prod.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			prod.code.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<div
			className="products-brands-company"
			style={{
				backgroundImage: `url(${fondo_productos})`,
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
			}}>
			{/* Productos */}
			<div className="products-company">
				<div className="content-sparkle">
					<h1 style={{ color: 'var(--theme-company)' }} className="sparkle u-hover--sparkle">
						Nuestros Productos
					</h1>
				</div>

				<div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 1rem" }}>
					<Grid container spacing={{ xs: 1, sm: 2 }}>
						{selectedProducts.map((product, index) => (
							<Grid item xs={6} sm={6} md={4} lg={3} key={index}>
								{/* Original card styling here */}
								<div className="card-photo-product" style={{ width: "100%", margin: 0 }} key={product?.key_product}>
									<div className="photo-product">
										<ImagenesGlobal url={product.img_url} type={'picture'} className="image-product-card" alt={product?.fullName} loadImageS={loadImageS} />
									</div>
									<div className="datos-product">
										<div className="code-precio">
											<span className="code-product">{product.code}</span>
											<span className="precio-product">{convertPrice(product?.sellingPrice_Max ?? '0.00', product?.currency)}</span>
										</div>
										<div className="description-product">
											<span className="des-product">
												{product.fullName.length > 50
													? `${product.fullName.slice(0, 50)}...`
													: product.fullName}
											</span>
										</div>
									</div>
								</div>
							</Grid>
						))}

						{/* Add Product Button */}
						<Grid item xs={6} sm={6} md={4} lg={3}>
							<div
								className="card-photo-product"
								onClick={() => setModalOpen(true)}
								style={{
									cursor: "pointer",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									flexDirection: "column",
									border: "2px dashed #aaa",
									width: "100%",
									margin: 0,
									minHeight: "200px",
								}}>
								<AddIcon sx={{ fontSize: 40 }} />
								<Typography variant="body2">Añadir Producto</Typography>
							</div>
						</Grid>
					</Grid>
				</div>
			</div>
			{/* Marcas */}
			<div className="brands-company">
				<div className="content-sparkle">
					<h1 className="sparkle u-hover--sparkle" style={{ color: 'var(--theme-company)' }}>
						Nuestras Marcas
					</h1>
				</div>

				<div className="brands-carousel-outer">
					<button onClick={handlePrevBrands} className="arrow-button-brands left-arrow-brands">
						&#10094;
					</button>

					<div className="brands-carousel-container">
						<div
							className="carousel-items-brands"
							style={{
								transform: translateX,
								transition: "transform 0.5s ease-in-out",
								width: widthDynamic,
							}}>
							{/* Mapeo de 'marcas' traídas de la API */}
							{marcas.map((brand, index) => (
								<div key={index} className="brand-item">
									<img src={`${API_URL}${brand.image}`} alt={brand.name} />
								</div>
							))}
						</div>
					</div>

					<button onClick={handleNextBrands} className="arrow-button-brands right-arrow-brands">
						&#10095;
					</button>
				</div>
			</div>
			{/* Modal con tabla */}
			<Modal open={modalOpen} onClose={() => setModalOpen(false)}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "#fff",
						p: {
							xs: 1,
							md: 3,
						},
						borderRadius: 2,
						width: {
							xs: "98%",
							sm: 520,
						},
					}}>
					<Typography variant="h6" mb={2}>
						Lista de productos
					</Typography>

					{/* 🔍 Buscador */}
					<TextField
						placeholder="Buscar por nombre o código..."
						fullWidth
						variant="outlined"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						sx={{ mb: 2 }}
					/>

					{/* Tabla filtrada */}
					<TableContainer component={Paper} sx={{ height: 400, overflowY: "auto" }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Producto</TableCell>
									<TableCell>Precio</TableCell>
									<TableCell>Código</TableCell>
									<TableCell>Acción</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{filteredProducts.map((prod) => (
									<TableRow key={prod.key_product}>
										<TableCell>{prod.fullName}</TableCell>
										<TableCell>{convertPrice(prod.sellingPrice_Max, prod?.currency)}</TableCell>
										<TableCell>{prod.code}</TableCell>
										<TableCell>
											<Checkbox
												checked={selectedProducts.includes(prod)}
												onChange={() => handleToggleProduct(prod)}
											/>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>

					<Box mt={2} display="flex" justifyContent="flex-end">
						<Button variant="outlined" onClick={() => setModalOpen(false)}>
							Cerrar
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default HomeProductosEdit;
